import { render, staticRenderFns } from "./Verb.vue?vue&type=template&id=11311228&scoped=true&"
import script from "./Verb.vue?vue&type=script&lang=js&"
export * from "./Verb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11311228",
  null
  
)

export default component.exports